import { Box, Typography, useTheme } from '@mui/material';
import { Fragment } from 'react';
import { buySearchCreditTexts } from 'src/common/config/TextMessage';
import { buySearchCreditModalSxs } from 'src/content/keywordResearch/keywordResearchCSS';

const SignupFooter = () => {
  const theme = useTheme(); // Access the theme
  const styles = buySearchCreditModalSxs(theme);

  return (
    <Fragment>
      <Box
        sx={{ flex: 1.4 }}
        className="flex items-center justify-evenly mt-5 md:m-0 flex-col md:flex md:flex-row w-full"
      >
        {/* Google Rating */}
        <div className="flex items-center">
          <Box>
            <img
              src={process.env.PUBLIC_URL + `/static/images/icons/google.svg`}
              alt="icon"
            />
          </Box>
          <Box>
            <img
              src={process.env.PUBLIC_URL + `/static/images/icons/stars.svg`}
              alt="icon"
            />
          </Box>
          <Typography sx={styles?.footerTypoSx}>{'4.9 rating'}</Typography>
        </div>

        {/* Community  */}
        <Box sx={styles?.subFooterBoxSx}>
          <img
            src={process.env.PUBLIC_URL + `/static/images/icons/community.svg`}
            alt="icon"
          />
          <Typography sx={styles?.footerTypoSx}>
            {buySearchCreditTexts?.footerTextFirst}
          </Typography>
        </Box>

        {/* Testimonials  */}
        <Box sx={styles?.subFooterBoxSx}>
          <img
            src={
              process.env.PUBLIC_URL + `/static/images/icons/testimonials.svg`
            }
            alt="icon"
          />
          <Typography sx={styles?.footerTypoSx}>
            {buySearchCreditTexts?.footerTextSecond}
          </Typography>
        </Box>
      </Box>
    </Fragment>
  );
};

export default SignupFooter;
